import { getChartPalette } from "../theme";
import { readableTextColor } from "./colors";
import type { ChartContext } from "./context";

export function buildTreemapOption(
  context: ChartContext,
): Record<string, unknown> {
  const { data, isDark, translateNode, unitText, ct, base } = context;
  const ds = data.datasets[0];
  if (!ds) return base;
  const vals = ds.values as unknown as Array<{ x: string; value: number }>;
  const colors = getChartPalette(isDark, vals.length);
  return {
    ...base,
    tooltip: {
      trigger: "item",
      backgroundColor: ct.bgElevated,
      borderColor: ct.border,
      formatter: (p: { name: string; value: number }) =>
        `${translateNode(p.name)}: ${unitText(p.value)}`,
    },
    series: [
      {
        type: "treemap",
        data: vals.map((v, i) => {
          const cellColor = colors[i % colors.length];
          return {
            name: v.x,
            value: v.value,
            itemStyle: { color: cellColor },
            label: { color: readableTextColor(cellColor) },
          };
        }),
        label: {
          show: true,
          formatter: (p: { name: string }) => translateNode(p.name),
        },
      },
    ],
  };
}
